import type { ProposalPayload } from "../ai-mode/types";

const CREATED_AT = "2026-03-05T11:42:38.428000";
const VALIDITY_DAYS = 7;
const VALIDITY_MS =
  new Date(CREATED_AT).getTime() + VALIDITY_DAYS * 24 * 60 * 60 * 1000;

export const MOCK_PROPOSAL_RESUMED: ProposalPayload = {
  uuid: "ec787c95-6664-495f-b8dc-c7673e5e0bfe",
  generatedAt: CREATED_AT,
  suggestedSpaces: [
    {
      id: "4e2753e6-d837-4e8d-b7c0-c31b1e64a8d2",
      partnerId: 3239,
      spaceName: "Dezker | Itaim Bibi",
      roomName: "sala 22 posições",
      city: "São Paulo",
      address: "Itaim Bibi, São Paulo",
      lat: -23.5821395,
      lng: -46.6721678,
      pricePerWorkstation: 1072.73,
      monthlyPrice: 23600,
      credits: 295,
      capacity: 22,
      sizeM2: 42,
      score: 10,
      amenities: [
        "acesso-24-7",
        "controle-de-acesso-digital",
        "acessibilidade",
        "ar-condicionado",
        "mobiliado",
        "cortina-ou-persiana",
        "portas-automaticas",
        "sala-climatizada",
        "vidro-com-isolamento-acustico",
        "gerador",
        "endereco-comercial",
        "endereco-fiscal",
        "escritorio-virtual",
        "limpeza-da-sala",
        "cafe-no-espaco",
        "copa",
        "sala-de-reuniao",
        "janela",
        "certificacao-do-predio-leed-gold-etc",
        "cozinha-equipada",
        "detectores-de-fumaca",
        "estacionamento-no-local",
        "estacionamento-proximo",
        "impressao-colorida",
        "impressao-pb",
        "vpn-private-network-rede-privada",
        "scanner-digitalizadora",
        "wi-fi",
        "impressora",
        "internet-cabeada",
        "link-dedicado",
        "cftv-circuito-fechado-de-tv",
        "recepcionista",
        "seguranca-monitorada-24h",
        "sistemas-de-sprinklers",
        "vigilancia-nas-areas-comuns-e-estacionamento",
      ],
      imageUrl:
        "https://d1y4va1nna2r1p.cloudfront.net/privaterooms/8fce9c8b-b12c-4126-841f-7ed22c1089e9.jpeg",
      images: [
        "https://d1y4va1nna2r1p.cloudfront.net/privaterooms/8fce9c8b-b12c-4126-841f-7ed22c1089e9.jpeg",
        "https://d1y4va1nna2r1p.cloudfront.net/privaterooms/aeb36fa8-7f35-4d95-877d-f069305b0c8b.jpeg",
        "https://d1y4va1nna2r1p.cloudfront.net/privaterooms/63e13898-ed87-4e43-8cc6-eb90d31636af.jpeg",
      ],
      isRecommended: true,
    },
    {
      id: "ac0e464a-1558-4e3e-b926-d1f6ec553434",
      partnerId: 3239,
      spaceName: "Dezker | Itaim Bibi",
      roomName: "205-6",
      city: "São Paulo",
      address: "Itaim Bibi, São Paulo",
      lat: -23.5821395,
      lng: -46.6721678,
      pricePerWorkstation: 1200,
      monthlyPrice: 28800,
      credits: 360,
      capacity: 24,
      sizeM2: 40,
      score: 9.76,
      amenities: [
        "acesso-24-7",
        "controle-de-acesso-digital",
        "acessibilidade",
        "ar-condicionado",
        "mobiliado",
        "endereco-comercial",
        "endereco-fiscal",
        "cafe-no-espaco",
        "telefone",
        "janela",
        "vpn-private-network-rede-privada",
        "wi-fi",
      ],
      imageUrl:
        "https://d1y4va1nna2r1p.cloudfront.net/privaterooms/14dd1f6b-c2d1-4206-a1d0-3869d7490034.jpeg",
      images: [
        "https://d1y4va1nna2r1p.cloudfront.net/privaterooms/14dd1f6b-c2d1-4206-a1d0-3869d7490034.jpeg",
        "https://d1y4va1nna2r1p.cloudfront.net/privaterooms/31589167-3eb6-4edc-823b-c37cb2a44a01.jpeg",
      ],
      isRecommended: true,
    },
    {
      id: "26b5e837-a72b-4e6c-afd4-5d0cede0e978",
      partnerId: 1342,
      spaceName: "LUNA",
      roomName: "Conjunto 91",
      city: "São Paulo",
      address: "Itaim Bibi, São Paulo",
      lat: -23.5831602,
      lng: -46.6781282,
      pricePerWorkstation: 601.6,
      monthlyPrice: 15040,
      credits: 188,
      capacity: 25,
      sizeM2: 100,
      score: 9.42,
      amenities: [
        "acesso-24-7",
        "controle-de-acesso-digital",
        "ar-condicionado",
        "mobiliado",
        "endereco-comercial",
        "endereco-fiscal",
        "cafe-no-espaco",
        "copa",
        "banheiro-privado",
        "janela",
        "scanner-digitalizadora",
        "wi-fi",
      ],
      imageUrl: "",
      images: [],
      isRecommended: true,
    },
  ],
  state: {
    currentStep: 3,
    completedSteps: [0, 1, 2, 3],
    diagnosis: {
      dealId: "12345",
      companyName: "Corp Total",
      contactName: "Brian Costa",
      contactEmail: "brian@corptotal.com.br",
      segment: "ENT (20 posições)",
      targetCity: "São Paulo",
      positionsMin: 20,
      positionsMax: 30,
      monthlyBudget: "40000",
      needs:
        "Corp Total busca escritório privativo para 20 pessoas em Faria Lima/Itaim Bibi, São Paulo, com prazo de 30 dias e orçamento de R$ 40.000/mês. Demanda recorrente confirmada para mudança de escritório de equipe fixa.",
    },
    location: null,
    adjustments: {
      creditsPrice: 0,
      contractMonths: 12,
      proposalValidity: VALIDITY_MS,
      sellerNotes: "",
      recommendedSpaceIds: [
        "4e2753e6-d837-4e8d-b7c0-c31b1e64a8d2",
        "ac0e464a-1558-4e3e-b926-d1f6ec553434",
        "26b5e837-a72b-4e6c-afd4-5d0cede0e978",
      ],
      spaceAdjustments: [
        {
          spaceId: "4e2753e6-d837-4e8d-b7c0-c31b1e64a8d2",
          extraValue: 0,
          margin: 0,
          clientPrice: 23600,
          credits: 295,
          extraCredits: 0,
          totalCredits: 295,
          totalPrice: 25488,
          setupCost: 1888,
          setupCredits: 24,
        },
        {
          spaceId: "ac0e464a-1558-4e3e-b926-d1f6ec553434",
          extraValue: 0,
          margin: 0,
          clientPrice: 28800,
          credits: 360,
          extraCredits: 0,
          totalCredits: 360,
          totalPrice: 31104,
          setupCost: 2304,
          setupCredits: 29,
        },
        {
          spaceId: "26b5e837-a72b-4e6c-afd4-5d0cede0e978",
          extraValue: 0,
          margin: 0,
          clientPrice: 15040,
          credits: 188,
          extraCredits: 0,
          totalCredits: 188,
          totalPrice: 16243.2,
          setupCost: 1203.2,
          setupCredits: 16,
        },
      ],
    },
  },
};
